import { Tabs, TabList, TabPanel, TabPanels, Tab } from '@chakra-ui/react'

import RatingTab from './RatingTab';

import { CRITICS } from "./constants/ratings";

function RatingTable() {
    return (
        <>
        <Tabs isLazy>
            <TabList>
                <Tab>Average</Tab>
                {CRITICS.map((critic) => (
                    <Tab key={critic}>{ critic }</Tab>
                ))}
            </TabList>    
            <TabPanels>
                <TabPanel padding={0} marginTop={5} key="average">
                    <RatingTab key={"average"} critic={"average"} />
                </TabPanel>
                {CRITICS.map((critic) => (
                    <TabPanel padding={0} marginTop={5} key={critic}>
                        <RatingTab key={critic} critic={critic} />
                    </TabPanel>
                ))}
            </TabPanels>
        </Tabs>
        </>
    )
}

export default RatingTable;
